import { useModal } from "@realtorSitesClient/hooks/useModal";
import { AuthDialog } from "./AuthDialog";
import { ModalType } from "@realtorSitesClient/store/modalSlice";

export function ModalProvider() {
  const { activeModal, params, closeModal } = useModal();

  return (
    <>
      <AuthDialog
        isOpen={activeModal === ModalType.Auth}
        onClose={closeModal}
        dialogParams={params[ModalType.Auth]}
      />
    </>
  );
}
